import React from 'react';
import styled from 'styled-components';
import Menu from '../../Components/UserComponents/Menu';
import NotificationList from '../../Components/UserComponents/NotificationList';

function UserNotifications({ title, isMobile }) {
  return (
    <UserNotificationsStyled>
      <Menu title={title} isMobile={isMobile} />
      <div className="list-container">
        <NotificationList />
      </div>
    </UserNotificationsStyled>
  );
}

const UserNotificationsStyled = styled.div`
  display: flex;
  width: 100%;
  min-height: 100vh;
  padding-top: 4rem;
  .list-container {
    flex: 6;
    .datatable {
      padding: 20px;
      .datatable-title {
        width: 100%;
        font-size: 14px;
        color: var(--accent-blue);
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
  }
`;

export default UserNotifications;
